import axios from 'axios';

// Regole feed Amazon / eBay (features/marketplacerules): "se il prodotto ... allora prezzo/quantita' ...".
// Le regole toccano solo prezzo e quantita'; titolo, categoria, marca servono solo a filtrare.

const buildUrl = (context, path) => `${context.rootGetters['settings/getUrl']}marketplacerules/${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return {
		error: Array.isArray(detail) ? detail.map(e => (typeof e === 'string' ? e : e.msg || e.param)).join(', ') : detail || err?.response?.status || true,
		status: err?.response?.status,
	};
};

const request = (promise, pick = data => data) => promise.then(res => pick(res.data)).catch(fail);

const actions = {
	// campi, operatori e azioni disponibili
	meta: context => request(axios.get(buildUrl(context, 'meta'), { headers: authHeader(context) })),

	// marche, categorie, tag, fornitori e paesi per le tendine delle condizioni
	options: (context, { platform }) => request(axios.get(buildUrl(context, `${platform}/options`), { headers: authHeader(context) })),

	// regole della piattaforma + esito dell'ultimo giro
	list: (context, { platform }) => request(axios.get(buildUrl(context, platform), { headers: authHeader(context) })),

	get: (context, { id }) => request(axios.get(buildUrl(context, `rule/${id}`), { headers: authHeader(context) })),

	save: (context, { platform, rule }) =>
		request(rule._id ? axios.put(buildUrl(context, `rule/${rule._id}`), rule, { headers: authHeader(context) }) : axios.post(buildUrl(context, platform), rule, { headers: authHeader(context) })),

	toggle: (context, { id, active }) => request(axios.patch(buildUrl(context, `rule/${id}/active`), { active }, { headers: authHeader(context) })),

	move: (context, { id, direction }) => request(axios.post(buildUrl(context, `rule/${id}/move`), { direction }, { headers: authHeader(context) })),

	duplicate: (context, { id }) => request(axios.post(buildUrl(context, `rule/${id}/duplicate`), {}, { headers: authHeader(context) })),

	remove: (context, { id }) => request(axios.delete(buildUrl(context, `rule/${id}`), { headers: authHeader(context) })),

	// cosa cambierebbe (rule = bozza in modifica, facoltativa); non manda niente ai marketplace
	preview: (context, { platform, rule }) => request(axios.post(buildUrl(context, `${platform}/preview`), { rule: rule || null }, { headers: authHeader(context) })),

	// applica adesso (in coda)
	sync: (context, { platform }) => request(axios.post(buildUrl(context, `${platform}/sync`), {}, { headers: authHeader(context) })),
};

export default {
	namespaced: true,
	actions,
};
